/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SenderOption } from './SenderOption';
import {
    SenderOptionFromJSON,
    SenderOptionFromJSONTyped,
    SenderOptionToJSON,
    SenderOptionToJSONTyped,
} from './SenderOption';
import type { StatsBucket } from './StatsBucket';
import {
    StatsBucketFromJSON,
    StatsBucketFromJSONTyped,
    StatsBucketToJSON,
    StatsBucketToJSONTyped,
} from './StatsBucket';

/**
 * 
 * @export
 * @interface StatsResponse
 */
export interface StatsResponse {
    /**
     * 
     */
    allTime: StatsBucket;
    /**
     * 
     */
    last7Days: StatsBucket;
    /**
     * 
     */
    senders: Array<SenderOption>;
    /**
     * 
     */
    species: Array<string>;
}

/**
 * Check if a given object implements the StatsResponse interface.
 */
export function instanceOfStatsResponse(value: object): value is StatsResponse {
    if ((!('allTime' in (value as Record<string, any>)) && !('all_time' in (value as Record<string, any>))) || ((value as Record<string, any>)['allTime'] === undefined && (value as Record<string, any>)['all_time'] === undefined)) return false;
    if ((!('last7Days' in (value as Record<string, any>)) && !('last_7_days' in (value as Record<string, any>))) || ((value as Record<string, any>)['last7Days'] === undefined && (value as Record<string, any>)['last_7_days'] === undefined)) return false;
    if (!('senders' in value) || value['senders'] === undefined) return false;
    if (!('species' in value) || value['species'] === undefined) return false;
    return true;
}

export function StatsResponseFromJSON(json: any): StatsResponse {
    return StatsResponseFromJSONTyped(json, false);
}

export function StatsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): StatsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'allTime': StatsBucketFromJSON(json['all_time']),
        'last7Days': StatsBucketFromJSON(json['last_7_days']),
        'senders': ((json['senders'] as Array<any>).map(SenderOptionFromJSON)),
        'species': json['species'],
    };
}

export function StatsResponseToJSON(json: any): StatsResponse {
    return StatsResponseToJSONTyped(json, false);
}

export function StatsResponseToJSONTyped(value?: StatsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'all_time': StatsBucketToJSON(value['allTime']),
        'last_7_days': StatsBucketToJSON(value['last7Days']),
        'senders': ((value['senders'] as Array<any>).map(SenderOptionToJSON)),
        'species': value['species'],
    };
}

